import React, { Fragment } from 'react'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import MarcasBebidaMezcalComponent from './MarcasBebidaMezcalComponent';
import MarcasMezcalComponent from './MarcasMezcalComponent';
import { obtenerMarcasBebidasCliente, obtenerMarcasMezcalCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import { useDispatch, useSelector } from 'react-redux'

function TabsMarcasComponent(props) {
    const dispatch = useDispatch()

    let detalleCliente = props?.detalle
    
    
    const [marcas, setMarcas] = React.useState(detalleCliente?.marcascliente.length > 0 ? 'marcasMezcal' : 'marcasBebidas');
    const handleChangeMarcas = (event, newValue) => {
        setMarcas(newValue);
    };
    const [marcasMezcal, setMarcasMezcal] = React.useState([]);
    const [ismodificacion, setIsModificacion] = React.useState(false);
    
    const [marcasBebidas, setMarcasBebidas] = React.useState([]);
    
    React.useEffect(async () => {
        if (marcas == 'marcasMezcal') {
            let resMarcasMezcal = await dispatch(obtenerMarcasMezcalCliente(detalleCliente?.idcliente))
            setMarcasMezcal(resMarcasMezcal?.payload)
        }
        if (marcas == 'marcasBebidas') {
            let resMarcasBebidas = await dispatch(obtenerMarcasBebidasCliente(detalleCliente?.idcliente))
            setMarcasBebidas(resMarcasBebidas?.payload)
        }
        setIsModificacion(false)
    }, [marcas,ismodificacion])
    
    return (
        <Fragment>
            <Box sx={{ width: '100%', typography: 'body1', marginTop: '3%' }}>
                <TabContext value={marcas}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        textAlign: 'center', backgroundColor: '#fcfcfc',
                        boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                    }}>
                        <TabList onChange={handleChangeMarcas} aria-label="lab API tabs example" className='text-center'
                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                            sx={{
                                "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                                "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                            }}>
                            { detalleCliente?.marcascliente.length > 0 &&
                                <Tab label="Marcas de Mezcal" value="marcasMezcal" />
                            }
                            { detalleCliente?.marcasproductoconmezcalcliente.length > 0 &&
                                <Tab label="Marcas de Bebidas con Mezcal" value="marcasBebidas" />
                            }
                        </TabList>
                    </Box>
                    <TabPanel value="marcasMezcal">
                        <div className='row'>
                            {ordenarActivosASC(sortJSON(marcasMezcal, 'isbaja', 'asc'), 'marcasmezcal')?.map((marca, index) =>
                                <MarcasMezcalComponent index={index} data={marca} setIsModificacion={setIsModificacion} />
                            )}
                        </div>
                    </TabPanel>
                    <TabPanel value="marcasBebidas">
                        <div className='row'>                            
                            {ordenarActivosASC(sortJSON(marcasBebidas, 'isbaja', 'asc'), 'marcasbebidasmezcal')?.map((marca, index) =>
                                <MarcasBebidaMezcalComponent index={index} data={marca} setIsModificacion={setIsModificacion}/>
                            )}
                        </div>
                    </TabPanel>
                </TabContext>
            </Box>
        </Fragment >
    )
}
function sortJSON(data, key, orden) {

    const dataCopy = [...data];

    return dataCopy.sort(function (a, b) {
        var x = a[key],
            y = b[key];
        if (orden === 'asc') {
            if (x === y) return 0;
            if (x === false) return -1;
            if (y === false) return 1;
            return 0;
        }
        if (orden === 'desc') {
            if (x === y) return 0;
            if (x === true) return -1;
            if (y === true) return 1;
            return 0;
        }
    });
}

function ordenarActivosASC(array, idName){
    let activos = []
    let inactivos = []

    array?.map(item => {
        if (item?.isbaja == false) activos.push(item)
        else if (item?.isbaja == true) inactivos.push(item)
    })

    if(activos.length > 1) {
        if (idName == 'marcasmezcal') activos.sort(((a, b) => a.idmarcascliente - b.idmarcascliente));
        else if (idName == 'marcasbebidasmezcal') activos.sort(((a, b) => a.idmarcasproductocliente - b.idmarcasproductocliente));
    }

    return activos.concat(inactivos);
}


export default TabsMarcasComponent